import { render, staticRenderFns } from "./tariffStatement.vue?vue&type=template&id=3e287c7b&scoped=true&"
import script from "./tariffStatement.vue?vue&type=script&lang=ts&"
export * from "./tariffStatement.vue?vue&type=script&lang=ts&"
import style0 from "./tariffStatement.vue?vue&type=style&index=0&id=3e287c7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e287c7b",
  null
  
)

export default component.exports